var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHex3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 26,
    viewBox: "0 0 105 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.09 0.980103H7.03L0 13.1601L7.03 25.3401H21.09L28.12 13.1601L21.09 0.980103Z",
    fill: "#F1805E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.08 0.560059H45.02L37.98 12.7401L45.02 24.9201H59.08L66.11 12.7401L59.08 0.560059Z",
    fill: "#F1805E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.06 0.560059H83L75.97 12.7401L83 24.9201H97.06L104.09 12.7401L97.06 0.560059Z",
    fill: "#D56B4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.09,
    height: 24.78,
    fill: "white",
    transform: "translate(0 0.560059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHex3);
export default __webpack_public_path__ + "static/media/hex_3.9c14d7b10be89b95b3dd9d60cdb0a3e9.svg";
export { ForwardRef as ReactComponent };